import { APIResourceService } from '@/core/services/APIService'
import Version from '@/core/resources/Version'
import { buildException } from '@/core/exceptions'

export class VersionService extends APIResourceService<Version> {
  constructor() {
    super(Version)
  }

  /**
   * Appel API pour upload le fichier README d'une collection
   * @param item La collection concernée
   * @param token Jeton de session JWT
   * @throws PolluxApiError si l'upload a échoué
   */
  uploadUsersGuide(item: Version, file: any, token: string): Promise<boolean> {
    Object.defineProperty(file, 'name', { writable: true })
    file.name = "User's Guide_" + item.name + '.pdf'
    const formData = new FormData()
    formData.append('file', file)

    return this.client
      .post('collections/' + item.name + '/upload_readme', formData, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }
}
